import CreditCardIcon from '@mui/icons-material/CreditCard';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import RowMenuItem from '../../DataGrid/RowMenuItem';
import { getPurchaseSubscriptionPath } from '../helpers';
import messages from '../messages';

const PurchaseSubscription = ({ device }) => (
  <>
    <RowMenuItem
      colorIcon="primary.main"
      colorText="primary.main"
      component={Link}
      icon={<CreditCardIcon />}
      label={<FormattedMessage {...messages.deviceDataGridActionDeviceRowMenuPurchase} />}
      to={getPurchaseSubscriptionPath(device)}
    />
    <Divider />
  </>
);

PurchaseSubscription.propTypes = {
  device: PropTypes.shape({
    site: PropTypes.shape({
      company: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    type: PropTypes.string,
  }).isRequired,
};

export default PurchaseSubscription;
